import React from 'react';
import './NotFoundPage.css'; // Use the same CSS file or create a specific one for styling

const ResetLinkExpired = () => {
  const handleRequestNewLink = () => {
    window.location.href = '/';
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>Reset Link Expired</h1>
        <h2>Oops! Your reset password link has expired</h2>
        <p>
          The link you used is no longer valid. This could happen if the link has expired or has already been used. 
        </p>
        <button onClick={handleRequestNewLink} className="home-button">
          Request a New Link
        </button>
      </div>
    </div>
  );
};

export default ResetLinkExpired;
